import { fromJS, List } from 'immutable';
import * as reduxHelper from 'store/utils/reduxHelper';
import Metric from 'models/GrowthPlan/Metric';
import { byId } from 'store/utils/sortFunctions';
import types from './types';

export const initialState = fromJS({
  ...reduxHelper.applyReceiveInfo({
    data: {
      byId: {},
      byProject: {},
    },
    errorMessage: '',
    updatePending: false,
  }),
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.METRICS_LIST_SUCCEEDED:
      return state.merge(
        reduxHelper.applyRequestInfo({
          data: {
            byId: action.payload.results.reduce(
              (prevData, metric) =>
                prevData.set(metric.id.toString(), new Metric(metric)).sort(byId),
              state.get('data').get('byId')
            ),
            byProject: state
              .get('data')
              .get('byProject')
              .set(
                String(action.payload.project),
                fromJS(action.payload.results.map(metric => new Metric(metric))).sort(byId)
              ),
          },
        })
      );
    case types.METRIC_FETCH_SUCCEEDED:
    case types.METRIC_CREATE_SUCCEEDED:
    case types.METRIC_UPDATE_SUCCEEDED: {
      const projectId = String(action.payload.project);
      const projectGoals = state
        .get('data')
        .get('byProject')
        .get(projectId, new List())
        .filter(metric => metric.id !== action.payload.id)
        .push(new Metric(action.payload))
        .sort(byId);
      return state.merge(
        reduxHelper.applyRequestInfo({
          updatePending: false,
          data: {
            byId: state
              .get('data')
              .get('byId')
              .set(action.payload.id.toString(), new Metric(action.payload)),
            byProject: state.get('data').get('byProject').set(projectId, projectGoals),
          },
        })
      );
    }
    case types.METRIC_FETCH:
    case types.METRIC_CREATE:
    case types.METRIC_UPDATE:
      return state.merge(
        reduxHelper.applyRequestInfo({
          updatePending: true,
        })
      );
    case types.METRIC_DELETE_SUCCEEDED: {
      const projectId = String(action.payload.project);
      const projectGoals = state
        .get('data')
        .get('byProject')
        .get(projectId, new List())
        .filter(metric => metric.id !== action.payload.id)
        .sort(byId);
      return state.merge(
        reduxHelper.applyRequestInfo({
          updatePending: false,
          data: {
            byId: state.get('data').get('byId').delete(action.payload.id.toString()),
            byProject: state.get('data').get('byProject').set(projectId, projectGoals),
          },
        })
      );
    }
    case types.METRIC_UPDATE_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          updatePending: false,
          errorMessage: action.payload,
        })
      );
    case types.METRIC_CLEAR_ERROR:
      return state.merge(reduxHelper.applyReceiveInfo());
    case types.METRIC_FETCH_FAILED:
    case types.METRICS_LIST_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          errorMessage: action.payload,
        })
      );
    default:
      return state;
  }
}
